<template>
  <VPopup
    class="assembly-info-popup"
    :target="target"
    :visible="true"
    align="left"
    show-pointer
  >
    <dl>
      <dt>Доставка:</dt>
      <dd class="nowrap">{{ assembly?.deliveryType?.name ?? '--' }}</dd>

      <dt>t° режим:</dt>
      <dd class="nowrap">
        <template v-if="assembly?.storeTemperatureRange">
          от {{ assembly.storeTemperatureRange.start }} °C
          до {{ assembly.storeTemperatureRange.end }} °C
        </template>
        <template v-else>--</template>
      </dd>
    </dl>
  </VPopup>
</template>

<style lang="scss" src="./AssemblyInfoPopup.scss"/>

<script lang="ts">
import type Assembly from '@/domains/Assemblies/Assembly';

export default defineComponent({
  name: 'AssemblyInfoPopup',

  props: {
    assembly: {
      type:    Object as PropType<Assembly>,
      default: null,
    },
    target: {
      type:    HTMLElement,
      default: null,
    },
  },
});
</script>
